<nav backgroundColor="warn" color="primary" mat-align-tabs="center" mat-tab-nav-bar [tabPanel]="tabPanel"
   mat-stretch-tabs="false">
   <a (click)="activeLink = '/setup/resourcing'" [active]="!activeLink || activeLink.startsWith('/setup/resourcing')"
      [routerLink]="'/setup/resourcing'" mat-tab-link>Resourcing</a>

   <a (click)="activeLink = '/setup/assignment'" [active]="activeLink.startsWith('/setup/assignment')"
      [routerLink]="'/setup/assignment'" mat-tab-link>Assignment</a>

   <a (click)="activeLink = '/setup/codes'" [active]="activeLink.startsWith('/setup/codes')"
      [routerLink]="'/setup/codes'" mat-tab-link>Codes</a>

   <a (click)="activeLink = '/setup/system'" [active]="activeLink.startsWith('/setup/system')"
      [routerLink]="'/setup/system'" mat-tab-link>System</a>

</nav>
<mat-tab-nav-panel #tabPanel>
   <router-outlet></router-outlet>
</mat-tab-nav-panel>